export default {
    none: 0,
    descriptionButton: 1,
    deleteButton: 2,
    updateButton: 4,
    advancedButton: 8,
    all: 1 | 2 | 4 | 8
}
